import store from "@/store";
import jwtDecode from "jwt-decode";
import { getInstance } from "../auth0-plugin";

interface DecodedToken {
  exp: number;
  iat: number;
  [key: string]: any;
}

export const refreshDpaIdToken = async () => {
  const authService = getInstance();
  const exchangeAPIUrl = store.state.stageConfig.exchangeAPIUrl;

  try {
    const accessToken = await authService.getAccessTokenSilently();
    const auth0IdToken = await authService.getIdTokenClaims();

    const response = await fetch(
      `${exchangeAPIUrl}/tokens/api/v1/exchange?ticket=${auth0IdToken.__raw}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Token exchange failed: ${response.status}`);
    }

    const tokenData = await response.text();
    store.commit("auth/setToken", tokenData);
    localStorage.setItem("dpaID-token", tokenData);

    return tokenData;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Failed to refresh dpaID token:", error);
    localStorage.removeItem("dpaID-token");
    store.commit("auth/setToken", null);
    throw error;
  }
};

/**
 * Check if token is expired or will expire soon (within 5 minutes)
 */
export const isTokenExpired = (
  token: string,
  bufferSeconds: number = 300
): boolean => {
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime + bufferSeconds;
  } catch (error) {
    // eslint-disable-next-line
    console.error("Failed to decode token:", error);
    return true;
  }
};

/**
 * Get a valid dpaID token, refreshing if necessary
 */
export const getValidDpaIdToken = async (): Promise<string> => {
  let token = localStorage.getItem("dpaID-token");

  if (!token || isTokenExpired(token)) {
    // eslint-disable-next-line
    console.log("Token expired or missing, refreshing...");
    token = await refreshDpaIdToken();
  }

  if (!token) {
    throw new Error("Failed to obtain valid token");
  }

  return token;
};
